export class InvtOrderDetailsModel {
    code_no: number;
    item_desc: string;
    qty_on_hand: number;
    code_fix: string;
    method_of_issue: string;
    issue_container: string;
    unit_per_issue: number;
    container_cost: number;
    unit_per_container: number;

    constructor(
        code_no: number,
        item_desc: string,
        qty_on_hand: number,
        code_fix: string,
        method_of_issue: string,
        issue_container: string,
        unit_per_issue: number,
        container_cost: number,
        unit_per_container: number
    ) {
        this.code_no = code_no;
        this.item_desc = item_desc;
        this.qty_on_hand = qty_on_hand;
        this.code_fix = code_fix;
        this.method_of_issue = method_of_issue;
        this.issue_container = issue_container;
        this.unit_per_issue = unit_per_issue;
        this.container_cost = container_cost;
        this.unit_per_container = unit_per_container;
    }
}
